import postscribe from 'postscribe'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('postscribe', postscribe)
})
